import { Chip, Stack, Typography } from '@mui/material';

import { replacePathParams } from 'utils/routes.utils';

import { Routes } from 'constants/routes.constants';

import LinkUnstyled from 'components/@common/LinkUnstyled';

interface Props {
  title: string;
  count: number;
  slug: string;
  onClick?: () => void;
}

const CollectionCard = ({ title, count, slug, onClick }: Props) => {
  return (
    <Stack
      component={LinkUnstyled}
      onClick={onClick}
      href={replacePathParams(Routes.CollectionDetail, { slug })}
      sx={[
        {
          p: 2,
          borderRadius: 4,
          bgcolor: 'grey.900',
          justifyContent: 'space-between',
          flex: 1,
          overflow: 'hidden',
        },
        (theme) => ({
          transition: theme.transitions.create(['background-color', 'opacity']),
          '&:hover': {
            backgroundColor: 'grey.800',
          },
          '&:active': {
            opacity: 0.8,
          },
        }),
      ]}
    >
      <Typography
        variant="h7"
        sx={{
          textTransform: 'uppercase',
          color: 'text.secondary',
          pb: 2,
          wordWrap: 'break-word',
        }}
      >
        {title}
      </Typography>
      <div>
        <Chip
          label={count}
          sx={{ bgcolor: 'background.default' }}
          size="small"
        />
      </div>
    </Stack>
  );
};

export default CollectionCard;
